import { render, staticRenderFns } from "./ViewTitlepage.vue?vue&type=template&id=1fc7b984&scoped=true"
import script from "./ViewTitlepage.vue?vue&type=script&lang=js"
export * from "./ViewTitlepage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc7b984",
  null
  
)

export default component.exports